<template>
  <div class="homePage">
    <home-banner ref="homeBanner" :height="580"></home-banner>
    <!-- 头条 -->
    <div class="TTouTiao">
      <div class="Tr"> 
        <el-carousel :interval="3000" height="186px">
          <el-carousel-item v-for="(item, index) in newsTextList" :key="index">
            <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }} </a>
            <router-link
              v-else
              target="_blank"
              :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
              > {{ item.title }}
            </router-link>     
          </el-carousel-item>
        </el-carousel>    
      </div>
    </div>
    <div class="clear"></div>
    <!-- 新闻动态第一部分 -->
    <div class="Tpage Part1" id="part1">
      <div class="NewsL">
        <div id="newsFlashItem" style="width:100%; overflow:hidden;">
          <div class="flashImg" style="display: block;">
            <div class="flashImg-container swiper-container" id="newsFlash1" v-show="activeNewsJt == 0">
              <div class="flashImg-wrapper swiper-wrapper"  >
                <div class="flashImg-slide swiper-slide"  v-for="(item,index) in flashImgList11" :key="index" >
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" >
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 410px ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                  <a
                    v-else
                    :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    target="_blank">
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 410px ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title }}</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination flashImg-pagin"></div>
            </div>
            <div class="flashImg-container swiper-container" id="newsFlash2" v-show="activeNewsJt == 1">
              <div class="flashImg-wrapper swiper-wrapper"  >
                <div class="flashImg-slide swiper-slide"  v-for="(item,index) in flashImgList12" :key="index" >
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" >
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 410px ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                  <a
                    v-else
                    :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    target="_blank">
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 410px ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination flashImg-pagin"></div>
            </div>
            <div class="flashImg-container swiper-container" id="newsFlash3" v-show="activeNewsJt == 2">
              <div class="flashImg-wrapper swiper-wrapper"  >
                <div class="flashImg-slide swiper-slide"  v-for="(item,index) in flashImgList13" :key="index" >
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" >
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 410px ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                  <a
                    v-else
                    :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    target="_blank">
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 410px ;">
                    <div class="txt">
                      <p class="txtTitle">{{item.title}}</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination flashImg-pagin"></div>
            </div>            
          </div>
        </div>                 
      </div>
      <div class="NewsR">
        <div class="Tit" id="NewsT" >
          <div 
            class="NewsRInner"
            :class="{ active: activeNewsJt == index }"
            v-for="(item,index) in catalogList" 
            :key="index"
            @mouseenter="mouseenterNewsJt(index)"
          >
            <a :href="item.url">{{item.title}}
            </a>
          </div>
        </div>
        <div class="ItemList" >
          <div class="NewsItem" v-if="activeNewsJt == 0">
            <div class="news_recomend">
              <div class="pull-left date">
                <div class="text-center date_u">{{ dayjs(newCatalogList01Tit.publishDate).format('DD') }}</div>
                <div class="text-center date_d">{{ dayjs(newCatalogList01Tit.publishDate).format('YYYY-MM') }}</div>
              </div>
              <div class="pull-right text">
                <a v-if="newCatalogList01Tit.url && newCatalogList01Tit.url !== ''" :href="newCatalogList01Tit.url">
                  <div class="t">{{newCatalogList01Tit.title}}</div>
                  <p></p>
                </a>
                <a v-else :href="`/detail/${newCatalogList01Tit.entTChannelUuid}/${newCatalogList01Tit.entTArticleUuid}`">
                  <div class="t">{{newCatalogList01Tit.title}}</div>
                  <p></p>
                </a>
              </div>
            </div>
            <ul class="comUl">
              <li v-for="(item,index) in newCatalogList01" :key="index"> 
                <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                <router-link
                  v-else
                  target="_blank"
                  :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                  >{{ item.title }}
                </router-link>
                <span class="span">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span> 
              </li>                     
            </ul>
          </div>
          <div class="NewsItem" v-if="activeNewsJt == 1">
            <div class="news_recomend">
              <div class="pull-left date">
                <div class="text-center date_u">{{ dayjs(newCatalogList02Tit.publishDate).format('DD') }}</div>
                <div class="text-center date_d">{{ dayjs(newCatalogList02Tit.publishDate).format('YYYY-MM') }}</div>
              </div>
              <div class="pull-right text">
                <a v-if="newCatalogList02Tit.url && newCatalogList02Tit.url !== ''" :href="newCatalogList02Tit.url">
                  <div class="t">{{newCatalogList02Tit.title}}</div>
                  <p></p>
                </a>
                <a v-else :href="`/detail/${newCatalogList02Tit.entTChannelUuid}/${newCatalogList02Tit.entTArticleUuid}`">
                  <div class="t">{{newCatalogList02Tit.title}}</div>
                  <p></p>
                </a>
              </div>
            </div>
            <ul class="comUl">
              <li v-for="(item,index) in newCatalogList02" :key="index"> 
                <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                <router-link
                  v-else
                  target="_blank"
                  :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                  >{{ item.title }}
                </router-link>
                <span class="span">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span> 
              </li>                     
            </ul>
          </div>
          <div class="NewsItem" v-if="activeNewsJt == 2">
            <div class="news_recomend">
              <div class="pull-left date">
                <div class="text-center date_u">{{ dayjs(newCatalogList03Tit.publishDate).format('DD') }}</div>
                <div class="text-center date_d">{{ dayjs(newCatalogList03Tit.publishDate).format('YYYY-MM') }}</div>
              </div>
              <div class="pull-right text">
                <a v-if="newCatalogList03Tit.url && newCatalogList03Tit.url !== ''" :href="newCatalogList03Tit.url">
                  <div class="t">{{newCatalogList03Tit.title}}</div>
                  <p></p>
                </a>
                <a v-else :href="`/detail/${newCatalogList03Tit.entTChannelUuid}/${newCatalogList03Tit.entTArticleUuid}`">
                  <div class="t">{{newCatalogList03Tit.title}}</div>
                  <p></p>
                </a>
              </div>
            </div>
            <ul class="comUl">
              <li v-for="(item,index) in newCatalogList03" :key="index"> 
                <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
                <router-link
                  v-else
                  target="_blank"
                  :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                  >{{ item.title }}
                </router-link>
                <span class="span">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span> 
              </li>                     
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>

    <!-- 通知公告 -->
    <div class="main_panel importNotice">
      <div class="t"><a href="/list/0177">通知公告：</a></div>
      <div class="Gd">
        <div class="swiperNotice swiper-container_2" id="swiperNotice">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in newsNoticeList" :key="index">
              <a
                :href="item.url && item.url !== '' ? item.url : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                target="_blank"
              >
                <span>{{ item.title }}</span>
                <span class="time">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <a href="http://www.gsskgjsjt.com/detail/0177/fbd017aa-1186-456a-adae-6f1153d5078f" class="fakeEnterprise"></a>
    </div>

    <!-- 业务板块 -->
    <div class="width_100 importYeWu">
      <div class="t"><img src="../assets/kg/ywbk_t.png"></div>
      <div class="main_panel Item">
        <div class="Left" id="YwLeft">
          <ul>
            <li
              id="YwLeftul"
              :class="{ active: active == index }"
              v-for="(item, index) in ywList"
              :key="index"
              @mouseover="mouseChange(item, index)"
            >
              <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.name }}</a>
              <router-link v-else target="_blank" :to="`/list/${item.entTChannelUuid}`">{{item.name}}</router-link>
            </li>
          </ul>
        </div>
        <div class="Right" id="YwRight">
          <div class="Rlist">
            <a :href="indexUrl" target="_blank">
              <img :src="indexImg" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>

    <!-- 党群建设和学习教育 -->
    <div class="main_panel">
      <div class="PComDivL margin_top_30">
        <div class="PComTit">
          <div class="cn">党群建设</div>
          <a href="/list/0170" class="Pmore">查看更多&gt;&gt;</a>
        </div>
        <div class="news_recomend">
          <div class="pull-left date">
            <div class="text-center date_u">{{ dayjs(partyNewsListTit.publishDate).format('DD') }}</div>
            <div class="text-center date_d">{{ dayjs(partyNewsListTit.publishDate).format('YYYY-MM') }}</div>
          </div>
          <div class="pull-right text">
            <a v-if="partyNewsListTit.url && partyNewsListTit.url !== ''" :href="partyNewsListTit.url">
              <div class="t">{{partyNewsListTit.title}}</div>
              <p></p>
            </a>
            <a v-else :href="`/detail/${partyNewsListTit.entTChannelUuid}/${partyNewsListTit.entTArticleUuid}`">
              <div class="t">{{partyNewsListTit.title}}</div>
              <p></p>
            </a>
          </div>
        </div>
        <ul class="comUl">
          <li v-for="(item,index) in partyNewsList" :key="index"> 
            <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
            <router-link
              v-else
              target="_blank"
              :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
              >{{ item.title }}
            </router-link>
            <span class="span">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span> 
          </li>    
        </ul>
      </div>
      <div class="PComDivR margin_top_30">
        <div class="PComTit">
          <div class="cn">学习教育</div>
          <a href="/list/0176" class="Pmore">查看更多&gt;&gt;</a>
        </div>
        <div class="news_recomend">
          <div class="pull-left date">
            <div class="text-center date_u">{{ dayjs(studyNewsListTit.publishDate).format('DD') }}</div>
            <div class="text-center date_d">{{ dayjs(studyNewsListTit.publishDate).format('YYYY-MM') }}</div>
          </div>
          <div class="pull-right text">
            <a v-if="studyNewsListTit.url && studyNewsListTit.url !== ''" :href="studyNewsListTit.url">
              <div class="t">{{studyNewsListTit.title}}</div>
              <p></p>
            </a>
            <a v-else :href="`/detail/${studyNewsListTit.entTChannelUuid}/${studyNewsListTit.entTArticleUuid}`">
              <div class="t">{{studyNewsListTit.title}}</div>
              <p></p>
            </a>
          </div>
        </div>
        <ul class="comUl">
          <li v-for="(item,index) in studyNewsList" :key="index"> 
            <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{item.title}}</a> 
            <router-link
              v-else
              target="_blank"
              :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
              >{{ item.title }}
            </router-link>
            <span class="span">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span> 
          </li>    
        </ul>
      </div>
    </div>
    <div class="clear"></div>

    <!-- 精品工程轮播图 -->
    <div class="Jpgcw width_100">
      <div class="main_panel t">
        <a href="/listPic/0178">
          <img src="../assets/kg/gcyj_t.png">
        </a>
      </div>
      <div class="main_panel" id="Jpgc">
        <div class="JpgcSwiper-container swiper-container" id="jpgcPhoto">
          <div class="JpgcSwiper-wrapper swiper-wrapper" >
            <div class="JpgcSwiper-slide swiper-slide"  v-for="(item,index) in JpgcPlayList" :key="index" >
              <a :href="item.url" v-if="item.url && item.url !== ''" class="JpItem" target="_blank" >
                <div class="img">
                  <img :src="item.thumb1" style="width: 100%; ">
                </div>
                <div class="Tit" >{{item.title }} </div>
              </a>
              <router-link
                v-else
                target="_blank"
                :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                >
                <div class="img">
                  <img :src="item.thumb1" style="width: 100%; ">
                </div>
                <div class="Tit" >{{item.title }} </div>
              </router-link>
            </div>
          </div>
          <!-- <div class="swiper-button-prev JpgcPrev"></div>
          <div class="swiper-button-next JpgcNext"></div> -->
        </div>
        <div class="swiper-button-prev JpgcPrev"></div>
        <div class="swiper-button-next JpgcNext"></div>
      </div>
    </div>

    <!-- 底部链接 -->
    <div class="main_panel">
      <div class="LinksList">
        <select onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
          <option value="#" selected="selected">————友情链接————</option>
            <option value="http://www.sinoron.com.cn">————华陇国际建设股份有限公司————</option>
            <option value="#">————华陇国际产业投资有限公司————</option>
            <option value="http://www.gsjssjjt.com">————甘肃省建设设计咨询集团有限公司————</option>
            <option value="http://www.gemceqpt.com">————甘肃建投重工科技有限公司————</option>
            <option value="#">————甘肃建投华东建设有限公司————</option>
            <option value="http://www.gsjtwy.com/">————甘肃建投物业管理有限公司————</option>
            <option value="#">————甘肃建投兰州新区建设管理有限公司————</option>
            <option value="#">————中甘国际国内工程公司————</option>
            <option value="#">————甘肃省集成装配式建筑产业发展有限公司————</option>
            <option value="http://www.gsjtstjs.com">————甘肃建投生态建设有限公司————</option>
            <option value="http://www.jinbmall.com/">————甘肃建投上海金播公司————</option>
            <option value="#">————甘肃天水绿色装配式建筑产业发展有限公司————</option>
            <option value="#">————甘建投陕新建设有限公司————</option>
            <option value="#">————甘肃建投华南建设有限公司————</option>
            <option value="#">————甘肃建投西南建设有限公司————</option>
            <option value="http://www.gcigcne.cn">————甘肃建投新能源科技股份有限公司————</option>
            <option value="#">————甘肃省城市建设投资有限责任公司————</option>
            <option value="http://www.gcctravel.cn/">————甘肃建投国际旅行社————</option>
            <option value="#">————甘肃建投重工科技有限公司————</option>
            <option value="#">————甘肃建投科技研发有限公司————</option>
            <option value="http://www.gsjtts.com/">————甘肃建投天水建设管理有限公司————</option>
            <option value="#">————甘肃建投华北建设有限公司————</option>
            <option value="#">————甘肃建投临夏建设管理有限公司————</option>
            <option value="http://www.gsjtxqglgs.com">————甘肃建投兰州新区建设管理有限公司————</option>
            <option value="#">————甘肃建投武威建设管理有限公司————</option>
            <option value="#">————甘肃建工建设机械制造有限责任公司————</option>
            <option value="http://www.gsjtzn.com">————甘肃建投智能工程有限公司————</option>
            <option value="#">————甘肃建设报社————</option>
            <option value="http://www.gsjtpxzx.com/">————甘肃建投培训中心————</option>
            <option value="http://www.gjtsst.com">————甘肃建投天水混凝土有限公司————</option>
            <option value="http://www.gsjtst.com">————甘肃建投商品混凝土有限公司————</option>
            <option value="http://www.gsjtky.com/">————甘肃建投矿业有限公司————</option>
            <option value="#">————甘肃建投文化旅游发展集团有限公司————</option>
            <!-- <option value="http://www.gsjt-gjg.com">————甘肃建投钢结构有限公司————</option> -->
            <option value="http://www.jtdzpt.com/">————甘肃建投资产经营有限公司————</option>
            <option value="http://www.gjkygs.com">————甘肃省建筑科学研究院有限公司————</option>
            <option value="http://www.gsjt56.com">————甘肃建投物流集团公司————</option>
            <option value="http://www.gcigcem.com.cn">————甘肃建投装备制造有限公司————</option>
            <option value="http://gsjiantouzhiye.com/">————甘肃建总置业发展有限公司————</option>
            <option value="http://www.gsjtsd.com/">————甘肃建投隧道工程有限公司————</option>
            <option value="http://www.gsjttm.com">————甘肃建投土木工程建设有限公司————</option>
            <option value="http://www.gsjtjs.com">————甘肃建投建设有限公司————</option>
            <option value="http://www.cgicop.com/">————中国甘肃国际经济技术合作总公司————</option>
            <option value="http://www.gsazjsjt.com/">————甘肃省安装建设集团公司————</option>
            <option value="http://www.gsya.com.cn/">————甘肃一安建设科技集团有限公司————</option>
            <option value="#">————甘肃第九建设集团公司————</option>
            <option value="http://www.gs8j.com/">————甘肃省第八建设集团有限责任公司————</option>
            <option value="http://www.gs7j.com.cn/">————甘肃省第七建设集团有限责任公司————</option>
            <option value="http://www.gsljw.com/">————甘肃第六建设集团股份有限公司————</option>
            <option value="http://www.gs5j.com/">————甘肃第五建设集团公司————</option>
            <option value="http://www.gssjjt.com/">————甘肃第四建设集团有限责任公司————</option>
            <option value="http://www.gssanjian.com">————甘肃第三建设集团公司————</option>
            <option value="http://www.gsejjt.cn/">————甘肃第二建设集团有限责任公司————</option>
            <option value="http://www.gsyj.com.cn">————甘肃第一建设集团有限责任公司————</option>
        </select>
        <select onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
          <option value="#" selected="selected">————行业链接————</option>
        </select>
        <select onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
          <option value="#" selected="selected">————省内各网站————</option>
        </select>
        <select onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
          <option value="#" selected="selected">————其他链接————</option>
        </select>
      </div>
    </div>
    <div class="clear"></div>
    
  </div>
</template>

<script>
import Swiper from "swiper"
import homeBanner from "@/components/swiper.vue"
import { articles, getTopArtList,picArticles,getChildChannel} from '@/api/common'
  export default {
    components: {
      homeBanner
    },
    data(){
      return {
        ywList: [],
        indexImg:'',
        indexUrl:'',
        activeNewsJt: 0,
        activeNewBasic : 0,
        activeNewStudy: 0,
        active: 0,
        ismouseover: true,
        //第一个新闻列表
        newCatalogList01Tit: {},
        newCatalogList02Tit: {},
        newCatalogList03Tit: {},
        newCatalogList01: [],
        newCatalogList02: [],
        newCatalogList03: [],
        partyNewsList: [],
        studyNewsList: [],
        partyNewsListTit: {},
        studyNewsListTit: {},

        JpgcPlayList: [], 
        //新闻列表轮播图
        flashImgList:[],
        //两个新闻图片的轮播
        flashImgList11: [],
        flashImgList12: [],
        flashImgList13: [],
        flashImgList22: [],
        //新闻目录一
        catalogList:[
          {
            id: 1,
            url: '/list/01690001',
            title: '公司动态',
          },
          {
            id: 2,
            url: '/list/01690002',
            title: '集团动态',
          },
          {
            id: 3,
            url: '/list/01690003',
            title: '行业动态',
          },
        ],
        newsNoticeList:[],
        //党建轮播图
        partyimgList:[],
        newsTextList: [],
      }
    },
    mounted() {
      this.bannerJpgc()
      this.getTopArtList()
      this.newsCatalog()
      this.picArticles()
      this.newsNotice()
      this.businessInit()
    },
    filters: {
      //超过100位显示 ...
      ellipsis: function(value) {
        if (!value) return ''
        if (value.length > 10) {
          return value.slice(0, 10) + '...'
        }
        return value
      }
    },
    methods: {
      mouseenterNewsJt(val) {
        this.activeNewsJt = val
      },
      //精品工程轮播图
      bannerJpgc() {
        var _this = this
        let data = {
          entTApplicationUuid: _this.webId,
          channelUuid: '0178',
          pageNum: 1,
          pageSize: 20
        }
        picArticles(data).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.JpgcPlayList = data.rows
            this.$nextTick(() => {
              this.swiper = new Swiper('#jpgcPhoto', {
                autoplay: 500,
                loop: true,
                speed: 4000,
                updateOnImagesReady : true,
                slidesPerView : 3,
                spaceBetween: 40,
                prevButton:'.JpgcPrev',
                nextButton:'.JpgcNext',
                observer: true,
                observeParents: true,
                observeSlideChildren: true,         
              })
            })
          }
        })
      },
      //头条新闻
      getTopArtList() {
        var _this = this
        let data = {
          applicationUuid: this.webId
        }
        getTopArtList(data).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.newsTextList = data
          }
        })
      },
      // 新闻动态
      newsCatalog() {
        var _this = this

        // 公司动态
        let data01 = {
          entTApplicationUuid: _this.webId,
          channelUuid: '01690001',
          pageNum: 1,
          pageSize: 6
        }
        articles(data01).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.newCatalogList01Tit = data.rows[0]
            _this.newCatalogList01 = data.rows.slice(1,6)
          }
        })

        // 集团动态
        let data02 = {
          entTApplicationUuid: _this.webIdGroup,
          channelUuid: '00190001',
          pageNum: 1,
          pageSize: 6
        }
        articles(data02).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
             _this.newCatalogList02Tit = data.rows[0]
            _this.newCatalogList02 = data.rows.slice(1,6)
          }
        })

        // 行业动态
        let data03 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "01690003",
          pageNum: 1,
          pageSize: 8
        }
        articles(data03).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
             _this.newCatalogList03Tit = data.rows[0]
            _this.newCatalogList03 = data.rows.slice(1,6)
          }
        })

        // 党群建设
        let data04 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "0170",
          pageNum: 1,
          pageSize: 8
        }
        articles(data04).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
             _this.partyNewsListTit = data.rows[0]
            _this.partyNewsList = data.rows.slice(1,8)
          }
        })

        // 学习教育
        let data05 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "0176",
          pageNum: 1,
          pageSize: 8
        }
        articles(data05).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
             _this.studyNewsListTit = data.rows[0]
            _this.studyNewsList = data.rows.slice(1,8)
          }
        })
      },
      // 新闻轮播图
      picArticles() {
        var _this = this
        
        //新闻第一部分轮播图 (公司动态)
        let data011 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "01690001",
          pageNum: 1,
          pageSize: 6
        }
        picArticles(data011).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.flashImgList11 = data.rows
            this.$nextTick(() => {
              new Swiper('#newsFlash1', {
                loop : true,
                autoplay: 3000,
                speed: 200,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                effect : 'fade',
                pagination: '.swiper-pagination',
                paginationClickable: true,
              })
            })
          }
        })

        //新闻第一部分轮播图 (集团动态)
        let data012 = {
          entTApplicationUuid:  _this.webId,
          channelUuid: '01690002',
          pageNum: 1,
          pageSize: 5
        }
        picArticles(data012).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.flashImgList12 = data.rows
            this.$nextTick(() => {
              new Swiper('#newsFlash2', {
                loop : true,
                autoplay: 3000,
                speed: 200,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                effect : 'fade',
                pagination: '.swiper-pagination',
                paginationClickable: true,
              })
            })
          }
        })

        //新闻第一部分轮播图 (行业动态)
        let data013 = {
          entTApplicationUuid: _this.webId,
          channelUuid: "01690003",
          pageNum: 1,
          pageSize: 5
        }
        picArticles(data013).then(res => {
          const { code, data } = res
          if (code === 1 && data ) {
            _this.flashImgList13 = data.rows
            this.$nextTick(() => {
              new Swiper('#newsFlash3', {
                loop : true,
                autoplay: 3000,
                speed: 200,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                effect : 'fade',
                pagination: '.swiper-pagination',
                paginationClickable: true,
              })
            })
          }
        })
      },
      // 通知公告
      newsNotice() {
        var _this = this
        let data = {
          entTApplicationUuid: _this.webId,
          channelUuid: '0177',
          pageNum: 1,
          pageSize: 10
        }
        articles(data).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.newsNoticeList = data.rows
            this.$nextTick(() => {
              this.swiper = new Swiper('#swiperNotice', {
                autoplay: 1,
                loop: true,
                speed: 10000,
                delay: 0,
                slidesPerView: 'auto',
                spaceBetween: 45,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                autoplayDisableOnInteraction: false
              })

              // 存放鼠标悬浮时的transform属性（行内属性）
              let nextTransForm = ''
              // 轮播图从暂停位置移动到原本应到的位置所用的时间
              let nextTime = 0

              // 鼠标悬浮暂停轮播
              this.swiper.container[0].onmouseover = function() {
                nextTransForm = document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transform
                // 轮播图原本应移动到的位置
                let nextTransPosition =
                  -1 *
                  parseInt(
                    document
                      .getElementsByClassName('swiper-container_2')[0]
                      .getElementsByClassName('swiper-wrapper')[0]
                      .style.transform.split('translate3d(')[1]
                      .split('px')[0]
                  )

                // 鼠标悬浮时时轮播图位置
                let nowTransPosition =
                  -1 *
                  parseInt(
                    window
                      .getComputedStyle(
                        document
                          .getElementsByClassName('swiper-container_2')[0]
                          .getElementsByClassName('swiper-wrapper')[0],
                        false
                      )['transform'].split('1, ')[2]
                      .split(',')[0]
                  )
                // 存放鼠标悬浮时轮播图的真实transform属性（非行内属性）
                let nowTransForm = window.getComputedStyle(
                  document.getElementsByClassName('swiper-container_2')[0].getElementsByClassName('swiper-wrapper')[0],
                  false
                )['transform']
                // 计算轮播图从暂停位置移动到原本应到的位置所用的时间（370是我自定义的每个slide的宽度）
                nextTime = 5500 * ((nextTransPosition - nowTransPosition) / 370)
                // 改变行内transform属性
                document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transform = nowTransForm
                // 不写也没关系
                document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = '0ms'
                this.swiper.stopAutoplay()
              }
              // 鼠标离开轮播图开始轮播
              this.swiper.container[0].onmouseout = function() {
                // console.log('leave' + nextTransForm)
                // 恢复原样
                document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transform = nextTransForm
                document
                  .getElementsByClassName('swiper-container_2')[0]
                  .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = nextTime + 'ms'
                this.swiper.startAutoplay()
              }
            })
          }
        })
      },
      mouseChange(val, index) {
        this.active = index
        this.indexImg = val.fileName
        if (val.url && val.url !== '') {
          this.indexUrl = val.url
        } 
        else {
          this.indexUrl = `/list/${val.entTChannelUuid}`
          this.indexImg = val.fileName
        }
      },
      // 业务板块
      businessInit() {
        var _this = this
        let data = {
          applicationUuid: _this.webId,
          parentUuid: '0171'
        }
        getChildChannel(data).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.ywList = data.slice(0,7)
            console.log('模块',_this.ywList)
            _this.indexImg = data[0].fileName
            data.length &&
              data.forEach(line => {
                if (line.url && line.url !== '') {
                  _this.indexUrl = line.url
                  _this.indexImg = line.fileName
                } 
              })
            }
        })
      },
    }
  } 
</script>

<style lang="scss">
// img{ 
//   -webkit-filter: grayscale(100%);
//   -moz-filter: grayscale(100%);
//   -ms-filter: grayscale(100%);
//   -o-filter: grayscale(100%); 
//   filter: grayscale(100%);
//   filter: url(/img/2013people/gray.svg#grayscale);
//   filter: gray;-webkit-filter: grayscale(1);
// }
// html {filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); filter: gray;-webkit-filter: grayscale(1);}
// .header .zt_banner img.xjp,.header .zt_banner img.database,.cpc_tit img{display:none;}
// .datalh{display:block;}
// .header{background:#666;}
.homePage{
  width: 100%;
  height: auto;
  overflow: hidden;
  font: 14px Helvetica Neue,Helvetica,PingFang SC,\5FAE\8F6F\96C5\9ED1,Tahoma,Arial,sans-serif;
}

//头条新闻
.TTouTiao {
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
  overflow: hidden;
}
.TTouTiao .Tr {
  height: 186px;
  width: 1200px;
}
.TTouTiao .Tr a {
  line-height: 60px;
  font-size: 36px;
  color: #000000;
  font-weight: bold;
  width: 100%;
  height: 186px;
  overflow: hidden;
  display: block;
  text-align: center;
  font-weight: bolder;
}
.TTouTiao .el-carousel__button {
  display: block;
  opacity: .2;
  width: 14px;
  height: 14px;
  border-radius: 14px;
  background-color: #000;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: .3s;
}
.TTouTiao .el-carousel__indicator.is-active button {
  width: 42px;
  background-color: #00a12a;
}
.clear{
  width: 100%;
  height: 10px;
  clear: both;
  overflow: hidden;
}
// 新闻动态部分
.homePage .Part1 {
  height: auto;
}
.homePage .Tpage {
  width: 1200px;
  overflow: hidden;
  margin: 0px auto;
}
.homePage .NewsL {
  width: 609px;
  overflow: hidden;
  float: left;
}

.homePage .NewsL .flashImg {
  width: 609px;
  height: 450px;
  overflow: hidden;
  position: relative;
}
.homePage .NewsL .flashImg-container{
  position: relative;
  width: 609px;
  height: 450px;
  overflow: hidden;
}
.homePage .NewsL .flashImg-slide{
  width: 609px;
  height: 450px;
}
.homePage .NewsL .flashImg-slide .swiper_img{
  height: 100%;
  width: 100%;
  
}
.homePage .NewsL .flashImg .flashImg-slide .txt {
  width: 100%;
  height: 40px;
  overflow: hidden;
  position: absolute;
  z-index: 3;
  left: 0px;
  top: 410px;
  text-indent: 34px;
  background-color: #fff;
}
.homePage  .NewsL .flashImg .txt .txtTitle {
  font-size: 16px;
  line-height: 40px;
  color: #000;
  font-weight: 900;
  overflow: hidden;/*超出部分隐藏*/
  text-overflow:ellipsis;/* 超出部分显示省略号 */
  white-space: nowrap;/*规定段落中的文本不进行换行 */
  width: 70%;/*需要配合宽度来使用*/
  margin-left: 2px;
  font-family: "微软雅黑", "宋体";
}
.homePage  .NewsL .swiper-pagination {
  position: absolute;
  text-align: right;
  z-index: 99;
  bottom: 8px;
}
.homePage  .NewsL .swiper-pagination-bullet {
  position: relative;
  width: 12px;
  height: 13px;
  margin: 0px 5px;
  font: 12px/15px "\5B8B\4F53";
  text-decoration: none;
  text-align: center;
  outline: 0;
  background-color: #959595;
  z-index: 99;
  border-radius: 0;
}
.homePage .flashImg .NewsL .flashImg-pagin .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
    bottom: 8px;
    width: 100%;
}
.homePage  .NewsL .swiper-pagination-bullet-active {
  background-color: #00a12a;
}

//新闻列表部分
.homePage  .NewsR {
  width: 560px;
  float: right;
  overflow: hidden;
}

.homePage  .NewsR .Tit {
  width: 100%;
  height: 48px;
  overflow: hidden;
  float: left;
}
.homePage  .NewsR .Tit a {
  width: 108px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  display: block;
  float: left;
  font-size: 22px;
  color: #575757;
  font-weight: bold;

}
a, a:focus, a:hover {
    text-decoration: none;
}
.homePage  .NewsR .Tit a.active{
  color: #0062b3;
  border-bottom: solid 2px #0062b3;
}
.homePage .NewsRInner.active a {
  color: #0062b3;
  border-bottom: solid 2px #0062b3;
}

.homePage  .NewsR .ItemList {
  width: 100%;
  overflow: hidden;
  clear: both;
}
.NewsR .news_recomend {
  width: 100%;
  height: auto;
  overflow: hidden;
  border-bottom: 1px #a8a9aa dashed;
  padding: 15px 0;
  margin-bottom: 28px;
}
.NewsR .news_recomend .text .t {
  width: 100%;
  height: 47px;
  color: #000000;
  line-height: 47px;
  font-size: 16px;
  font-weight: 800;
}
.NewsR .news_recomend .date {
  width: 108px;
  height: auto;
  overflow: hidden;
}
.pull-left {
  float: left!important;
}
.NewsR .news_recomend .date .date_u {
  width: auto;
  height: 70px;
  overflow: hidden;
  color: #787878;
  font-size: 46px;
  font-weight: 900;
  line-height: 70px;
}
.text-center {
  text-align: center;
}
.NewsR .news_recomend .date .date_d {
  width: auto;
  height: 30px;
  overflow: hidden;
  color: #787878;
  font-size: 18px;
  font-weight: 900;
  line-height: 30px;
}
.NewsR .news_recomend .text {
  width: 440px;
  height: auto;
  overflow: hidden;
}
.pull-right {
  float: right!important;
}
.homePage  .NewsR .ItemList .comUl {
  padding-left: 20px;
  overflow: hidden;
}
.comUl li {
  width: 100%;
  height: 43px;
  line-height: 43px;
}
.comUl li a {
  float: left;
  white-space: nowrap;
  display: block;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
  color: #000000;
  font-size: 16px;
}
.comUl li span {
  float: right;
  font-size: 16px;
}

.homePage .NewsR .ItemList .NewsItem .comUl li a:hover {
  animation: newshov  0.3s linear 1;
  color: #0162b3;
}
@keyframes newshov{
    from{transform:translateY(0px);}
    to{transform:translateY(-6px);}
}

.clear {
  width: 100%;
  height: 10px;
  overflow: hidden;
  display: block;
  clear: both;
}
//重要公告
.importNotice {
  height: 30px;
  margin-top: 30px;
}
.main_panel {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.importNotice .t {
  width: 90px;
  height: 30px;
  overflow: hidden;
  float: left;
  margin-top: 24px;
}
.importNotice .t a {
  font-size: 16px;
  color: #0062b3;
  font-weight: bold;
  line-height: 30px;
}
.importNotice .Gd {
  // width: 1110px;
  width: 940px;
  height: 30px;
  overflow: hidden;
  float: left;
  margin-top: 24px;
}
#swiperNotice .swiper-slide {
  width: auto;
}
.importNotice .Gd a {
  height: 30px;
  overflow: hidden;
  line-height: 30px;
  display: block;
  float: left;
  margin: 0px 20px;
  font-size: 16px;
  color: #0062b3;
}
.importNotice .Gd a:hover {
  font-weight: bold;
}

.importNotice .Gd a span {
  display: inline-block;
  float: left;
  margin-right: 20px;
}
// 假冒国企公告专栏
.fakeEnterprise {
  display: block;
  float: right;
  width: 160px;
  height: 50px;
  background: url(../assets/image/jmgqggzl.jpg) center no-repeat;
  background-size: cover;
  margin-top: 15px;
}
//业务板块
.importYeWu {
  height: 764px;
  margin-top: 40px;
  overflow: hidden;
  background: url(../assets/kg/ywbk_bg.jpg) center no-repeat;
  background-size: cover;
}
.width_100 {
  width: 100% !important;
}
.importYeWu .t {
  width: 468px;
  height: 72px;
  overflow: hidden;
  margin: 50px auto 26px auto;
}
.importYeWu .Item {
  height: 533px;
  overflow: hidden;
}
.main_panel {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.importYeWu .Item .Left {
  width: 273px;
  height: 533px;
  overflow: hidden;
  position: absolute;
  z-index: 2;
}
.importYeWu .Item .Left ul {
  padding-left: 0px;
}
.importYeWu .Item .Left ul li {
  width: 100%;
  height: 76px;
  overflow: hidden;
}
.importYeWu .Item .Left ul a:hover {
  color: #fff;
  background-color: #136ac4;
}
.importYeWu .Item .Left ul a:active {
  color: #fff;
  background-color: #136ac4;
}
.importYeWu .Item .Left ul li.active a {
  color: #fff;
  background-color: #136ac4;
}
.importYeWu .Item .Left ul li.active {
  background: url(../assets/kg/importYeWu_li.png) right center no-repeat;
}
.importYeWu .Item .Left ul li img {
  display: none;
}
.importYeWu .Item .Left ul li img.active {
  display: block;
}
.importYeWu .Item .Left ul li a {
  width: 259px;
  height: 76px;
  display: block;
  background-color: #0062b2;
  border-bottom: 2px #fff solid;
  text-align: center;
  line-height: 76px;
  font-size: 20px;
  overflow: hidden;
  color: #FFFFFF;
  font-weight: bold;
}
.importYeWu .Item .Right {
  width: 942px;
  height: 532px;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  margin-left: 259px;
}
.importYeWu .Item .Right a {
  width: 942px;
  height: 533px;
  overflow: hidden;
  display: block;
}
.importYeWu .Item .Right img {
  width: 942px;
  height: 533px;
  transition: all 2s ease-in;
  -webkit-transition: 2s all ease-in; /* 适用Safari 和 Chrome兼容 */
  -moz-transition: 2s all ease-in; /* 适用Firefox兼容 */
  -ms-transition: 2s all ease-in; /* 适用IE9兼容 */
  -o-transition: 2s all ease-in; /* Opera */
}
.homePage .importYeWu .Item .Right img:hover {
  transform: scale(1.1);
  -webkit-transform: scale(1.2); /*在Safari 和 Chrome兼容下还原*/
  -moz-transform: scale(1.1); /*在Firefox兼容下还原*/
  -ms-transfrom: scale(1.1); /*在IE9兼容下还原*/
  -o-transform: scale(1.1); /*在opera兼容下还原*/
  transform: scale(1.1); /*适用于所有浏览兼容下还原*/
}
//党群建设 学习教育
.PComDivL {
  width: 585px;
  float: left;
}
.PComDivR {
  width: 585px;
  float: right;
}
.margin_top_30 {
  margin-top: 30px;
}
.PComTit {
  width: 100%;
  height: 48px;
  overflow: hidden;
}
.PComTit .cn {
  width: 108px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  display: block;
  float: left;
  font-size: 22px;
  color: #0062b3;
  border-bottom: solid 2px #0062b3;
  font-weight: bold;
}
.Pmore {
  width: 88px;
  height: 30px;
  line-height: 30px;
  float: right;
  overflow: hidden;
  display: block;
  margin-top: 20px;
  color: #0062b3;
  font-size: 15px;
}
.PComDivL .news_recomend, .PComDivR .news_recomend {
  width: 100%;
  height: auto;
  overflow: hidden;
  border-bottom: 1px #a8a9aa dashed;
  padding: 15px 0;
  margin-bottom: 28px;
}
.PComDivL .news_recomend .date, .PComDivR .news_recomend .date {
  width: 108px;
  height: auto;
  overflow: hidden;
}
.pull-left {
  float: left!important;
}
.PComDivL .news_recomend .date .date_u, .PComDivR .news_recomend .date .date_u {
  width: auto;
  height: 70px;
  overflow: hidden;
  color: #787878;
  font-size: 46px;
  font-weight: 900;
  line-height: 70px;
}
.PComDivL .news_recomend .date .date_d, .PComDivR .news_recomend .date .date_d {
  width: auto;
  height: 30px;
  overflow: hidden;
  color: #787878;
  font-size: 18px;
  font-weight: 900;
  line-height: 30px;
}
.text-center {
  text-align: center;
}
.PComDivL .news_recomend .text, .PComDivR .news_recomend .text {
  width: 440px;
  height: auto;
  overflow: hidden;
}
.PComDivL .news_recomend a {
  font-family: "微软雅黑", "Microsoft YaHei",sans-serif;
  font-size: 16px;
  color: #000000;
}
.PComDivL .comUl , .PComDivR .comUl{
  padding-left: 20px;
  overflow: hidden;
}
.PComDivL .comUl li , .PComDivR .comUl li{
  width: 100%;
  height: 43px;
  line-height: 43px;
}
.PComDivL .comUl li a , .PComDivR .comUl li a{
  float: left;
  white-space: nowrap;
  display: block;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
  color: #000000;
  font-size: 16px;
}
.PComDivL .comUl li span , .PComDivR .comUl li span{
  float: right;
  font-size: 16px;
  color: #000000;
  font-size: 16px;
}
.PComDivL .news_recomend .text .t, .PComDivR .news_recomend .text .t {
  width: 100%;
  height: 47px;
  color: #000000;
  line-height: 47px;
  font-size: 16px;
  font-weight: 800;
}
//工程业绩
.Jpgcw {
  margin-top: 30px;
  height: 590px;
  overflow: hidden;
  background: url(../assets/kg/gcyj_bg.jpg) center no-repeat;
  background-size: cover;
}
.width_100 {
  width: 100% !important;
}
.Jpgcw .t {
  margin: 75px auto 55px auto;
  width: 468px;
  height: 77px;
  overflow: hidden;
}
#Jpgc {
  height: auto;
  overflow: hidden;
}
.Jpgcw .img img {
  width: 100%;
  height: 266px;
}
.Jpgcw .img {
  width: 100%;
  height: 266px;
  overflow: hidden;
}
.JpItem {
  width: 100%;
  height: 366px;
  display: block;
  overflow: hidden;
}
.Jpgcw .Tit {
  width: 100%;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #000;
  font-weight: bold;
  font-size: 18px;
}
#Jpgc .swiper-button-prev {
  top: auto;
  margin-top: -245px;
  left: auto;
  background-image: none;
  color: #fff;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  background-image: url(../assets/kg/left.png);
  margin-left: -40px;
}
#Jpgc .swiper-button-next {
  top: auto;
  margin-top: -245px;
  left: auto;
  margin-left: 1215px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  background-image: url(../assets/kg/right.png);
}
#Jpgc .swiper-button-next {
right: auto;
}
#Jpgc .swiper-button-next, .swiper-button-prev {
  position: absolute;
  width: 27px;
  height: 44px;
  z-index: 10;
  cursor: pointer;
  background-size: 27px 44px;
  background-position: 50%;
  background-repeat: no-repeat;
}
//底部链接
.main_panel {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.LinksList {
  width: 1244px;
  height: auto;
  overflow: hidden;
  margin-bottom: 50px;
}
.LinksList select {
  color: #004b8e;
  border-color: #004b8e;
  font-size: 15px;
  width: 267px;
  height: 31px;
  margin-right: 44px;
  float: left;
}
.LinksList select {
  /*将默认的select选择框样式清除*/
  appearance:none;
  -moz-appearance:none;
  -webkit-appearance:none;
  /*在选择框的最右侧中间显示小箭头图片*/
  background: url(../assets/kg/down2.png) no-repeat scroll right center transparent;
   background-size: 12px;
}
/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
select::-ms-expand {
  display: none;
}

</style>

